import { useState, useEffect } from 'react';

import Home from "./pages/Home";
import Blog from "./pages/Blog";
import Article from "./pages/Article";
import Nav from "./components/Nav";
import Footer from "./components/Footer";
import NotFound from "./pages/NotFound";

import './App.css';
import UIKitSection from './pages/UIKit';

function App() {
  const path = typeof window !== 'undefined' ? window.location.pathname : '/';
  const hash = typeof window !== 'undefined' ? window.location.hash : '';
  const language = path.includes('/ro') ? 'ro' : 'en';

  useEffect(() => {
    if (hash) {
      const element = document.getElementById(hash.substring(1));
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }
  }, [hash]);

  const Page = () => {
    if (path.includes('/blog')) return <Blog language={language} />
    if (path.includes('/article')) {
      const id = path.split('/article/')[1];
      return <Article id={id} language={language} />
    }
    // dev-only
    if (path === '/ui-kit') return <UIKitSection />
    if (path === '/' || path.startsWith("/ro")) return <Home language={language} />
    return <NotFound language={language} />
  }

  return (
    <div>
      <Nav language={language} />
      <Page />
      <Footer language={language} />
    </div>
  );
}

export default App;
